import { apiGet, apiPost } from '@/utils/api';
import getPath from '@/utils/getPath';
import { handleApiError } from '@/utils/errorHandler';

export const productivityApi = {
  /**
   * Fetches productivity overview (goal summary) for the given filters.
   * @apiRoute GET '/productivity/goals/summary'
   */
  async getOverview(params) {
    try {
      const response = await apiGet(
        getPath('productivity/goals/summary'),
        params
      );
      return response.data;
    } catch (err) {
      await handleApiError(
        err,
        'getOverview',
        true,
        'Error fetching productivity data'
      );
    }
  },

  /**
   * Fetches paginated productivity activity details for the given filters.
   * @apiRoute GET '/productivity/activities'
   */
  async getDetails(params) {
    try {
      const response = await apiGet(getPath('productivity/activities'), params);
      return response.data;
    } catch (err) {
      await handleApiError(
        err,
        'getDetails',
        true,
        'Error fetching productivity details'
      );
    }
  },

  /**
   * Saves a journal adjustment for a productivity entry.
   * @apiRoute POST '/productivity/activity/<int:productivity_activity_id>/adjustment'
   */
  async saveJournalAdjustment(productivityId, edits) {
    try {
      const response = await apiPost(
        getPath(`productivity/activity/${productivityId}/adjustment`),
        edits
      );
      return response.data;
    } catch (err) {
      await handleApiError(
        err,
        'saveJournalAdjustment',
        true,
        'Error saving changes'
      );
    }
  },
};
